export enum PazaakTurnState {
  INVALID = -1,
  DRAW_CARD = 0,
  PLAY_HAND_CARD = 1,
  END_TURN = 2,
  WAITING = 3,
  STAND = 4
}

